import React from 'react';

import ModalContainer from '@components/modals/ModalContainer';
import ModalHeader from '@components/modals/ModalHeader';

const UploadResultModal = ({ errorResponse, onCloseModal }) => {
	const renderErrorTable = () => {
		return (
			<table className="table height-sm">
				<thead>
					<tr>
						<th>Failed Images</th>
					</tr>
				</thead>
				<tbody>
					{errorResponse?.errorList?.map((item, index) => {
						return (
							<tr key={`error_${index}_${item.name}`}>
								<td>{item.name}</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		);
	};
	return (
		<ModalContainer onCloseModal={onCloseModal}>
			<div className="common-popup">
				<ModalHeader
					title={`${errorResponse?.successCount}/${errorResponse?.failureCount + errorResponse?.successCount} Successfully Uploaded`}
					onClose={onCloseModal}
				/>
				<div className="common-popup-body scroll-y-label">
					{errorResponse?.errorList?.length > 0 ? (
						renderErrorTable()
					) : (
						<div className="alert alert-secondary text-center gap-sm">
							<p>No failed image</p>
						</div>
					)}
				</div>
				<div className="modal-footer"></div>
			</div>
		</ModalContainer>
	);
};

export default UploadResultModal;
